<!-- data table -->
<div 
*ngIf="!isMobile"
matSort 
class="table-div"
(matSortChange)="sortData($event)">
    <table class="table table-striped">
        <thead>
            <tr>
                <th 
                scope="col"
                mat-sort-header="sku">
                    SKU
                </th>
                
                <th 
                scope="col"
                mat-sort-header="product_name">
                    Product Name
                </th>

                <th 
                scope="col"
                mat-sort-header="base_price">
                    Base Price
                </th>
                
                <th 
                scope="col" 
                mat-sort-header="beginning_epin_counts">
                   Beggining Epin Balance
                </th>

                <th 
                scope="col"
                mat-sort-header="beginning_total_amount">
                    Total Amount
                </th>

                <th 
                scope="col" 
                mat-sort-header="end_epin_counts">
                    End Epin Balance
                </th>

                <th 
                scope="col"
                mat-sort-header="end_total_amount">
                    Total Amount
                </th>
                
            </tr>
        </thead>
        <tbody *ngIf="!isLoading && !message">
            <tr class="user-tr" (click)="onItemClick(epin)" *ngFor="let epin of epinListData; index as i">
                <td>{{ epin.sku ?? 'N/A' }}</td>
                <td>{{ epin.product_name ?? 'N/A' }}</td>
                <td>{{ epin.base_price ?? 'N/A' }}</td>
                <td>{{ epin.beginning_epin_counts ?? 'N/A' }}</td>
                <td>{{ epin.beginning_total_amount ?? 'N/A' }}</td>
                <td>{{ epin.end_epin_counts ?? 'N/A' }}</td>
                <td>{{ epin.end_total_amount ?? 'N/A' }}</td>
            </tr>
        </tbody>

        <div 
        *ngIf="message && !isLoading" 
        class="m-auto error-message">
            <span>{{message}}</span>
        </div>
        
        <div *ngIf="isLoading" class="table-spinner-div">
            <span class="sr-only"> <div class="spinner-border" role="status"> </div> Loading...</span>
        </div>
        
    </table>

    <app-user-details/>

</div>
